/**
 * Stacking ranks for every floating surface.
 *
 * Radix portals an overlay and its content as two independent nodes appended to
 * `document.body`, and their relative order there is not stable: a close/reopen
 * cycle can re-append the overlay after the content it belongs to. While both
 * carried the same z-index that reordering let an overlay paint over its own
 * dialog and swallow every click aimed at it, so a confirm raised from the
 * member drawer became unclickable.
 *
 * Ranks fix the order in CSS instead of relying on DOM order: content always
 * outranks its own overlay, popups outrank dialog content so a select inside a
 * dialog still opens above it, and the app-wide confirm outranks the sheet or
 * dialog that raised it.
 */
export const LAYER = {
  /** Dimmer behind a dialog or sheet. */
  overlay: 'z-50',
  /** Dialog / sheet panel. */
  content: 'z-[51]',
  /** Anchored popups — select, dropdown, popover, tooltip. */
  popup: 'z-[55]',
  /** Dimmer behind the app-wide confirm. */
  alertOverlay: 'z-[60]',
  /** The app-wide confirm panel — nothing in the app may cover it. */
  alertContent: 'z-[61]',
  /**
   * The identity watermark. Above every panel on purpose: a screenshot of an
   * open approval dialog has to carry the stamp too. It takes no pointer
   * events, so outranking the confirm costs nothing in clickability.
   */
  watermark: 'z-[70]',
} as const;
